import { render, staticRenderFns } from "./LoopItem.vue?vue&type=template&id=9d9af712&scoped=true&"
import script from "./LoopItem.vue?vue&type=script&lang=js&"
export * from "./LoopItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9af712",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d9af712')) {
      api.createRecord('9d9af712', component.options)
    } else {
      api.reload('9d9af712', component.options)
    }
    module.hot.accept("./LoopItem.vue?vue&type=template&id=9d9af712&scoped=true&", function () {
      api.rerender('9d9af712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Sidebar/LoopItem.vue"
export default component.exports